import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'paya-redirection');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'payment_orders',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['paymentOrderId'],
    },
    'paya',
    'hosted_payment_pages',
    {
      type: 'payload.query',
      queryParameter: 'client_type',
      value: 'web',
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/paya-redirection-req.js